<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32">
      <path
        fill="inherit"
        stroke="none"
        d="M17 15h9.63a10.5 10.5 0 0 0-3.08-6.56A10.4 10.4 0 0 0 17 5.37zm-2 11.63V5.37A10.3 10.3 0 0 0 8.1 8.8 10.4 10.4 0 0 0 5.33 16q0 4.17 2.77 7.21a10.3 10.3 0 0 0 6.9 3.42m2 0a10.3 10.3 0 0 0 6.56-3.06q2.7-2.7 3.07-6.57H17zm-1 2.04q-2.63 0-4.94-1a12.8 12.8 0 0 1-6.73-6.73q-1-2.31-1-4.94t1-4.94a12.8 12.8 0 0 1 6.73-6.73q2.31-1 4.94-1t4.93 1a13 13 0 0 1 6.74 6.74q1 2.3 1 4.93 0 2.61-1 4.91A12.7 12.7 0 0 1 16 28.67"
      />
    </svg>
  </span>
</template>
